module.exports = __webpack_public_path__ + "static/media/sam.aca86672.jpg";